import { render, staticRenderFns } from "./firebase_reset_component.vue?vue&type=template&id=a875a26e"
import script from "./firebase_reset_component.vue?vue&type=script&lang=js"
export * from "./firebase_reset_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports